import { fieldTypes } from "../utils/validator";
let isRequired = true;

export const listitemObject = {
  name: fieldTypes.Text(null, 'Name', isRequired, '', { maxLen: 50 }),
  code: fieldTypes.Text(null, 'Code', isRequired, '', { noSpaces: true, maxLen: 30 }),
  list: fieldTypes.Text(null, 'List', isRequired)
};
